/** Whether the system clipboard holds anything to paste, resolved BEFORE a
 *  block menu opens so Paste never flashes in and out. Refused, unreadable or
 *  slower than the timeout all answer "yes" — Paste stays offered, as it
 *  always was. Shared by the Spec Studio and Designer menus. */
export function probeClipboardHasContent(timeoutMs = 80): Promise<boolean> {
  const probe = (async () => {
    try {
      const items = await navigator.clipboard.read();
      return items.some((i) => i.types.length > 0);
    } catch {
      return true;
    }
  })();
  const timeout = new Promise<boolean>((resolve) => setTimeout(() => resolve(true), timeoutMs));
  return Promise.race([probe, timeout]);
}
